<template>
    <v-container
            fluid
            style="min-height: 0;"
    >
        <!--<div class="headline pt-2 pb-2 grey&#45;&#45;text text&#45;&#45;darken-1">Supported profile providers</div>-->
        <v-container fluid grid-list-md>
            <v-layout row wrap>
                <v-flex
                    xs12
                    md2
                    v-for="(item, index) in providers"
                    :key="item.Code"
                >
                    <profile-provider-card :provider="item" @select="detail(item.Code)"></profile-provider-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-container>
</template>

<script>
    import { mapState } from 'vuex';
    import ProfileProviderCard from '../components/ProfileProviderCard';

    export default {
        components: {
            ProfileProviderCard,
        },
        name: 'providers',
        data() {
            return {
                title: 'Profile Providers',
            };
        },
        computed: {
            ...mapState('profileProviders', {
                providers: state => state.providers,
            }),
        },
        methods: {
            detail(code) {
                this.$router.push({ path: `/providers/${code}` });
            },
        },
        created() {
            this.$store.commit('nav/BREADCRUMBS', [
                { id: 'providers', text: 'Profile Providers', to: '/providers' },
            ]);

            this.$store.dispatch('profileProviders/LIST_ALL');
        },
    };
</script>



// WEBPACK FOOTER //
// ProfileProviders.vue?9a9d3de4